'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var deprecatedTimezones = require('./deprecated-timezones.js');

function mapDeprecatedTimezones(timezone) {
  if (Object.keys(deprecatedTimezones.deprecatedTimezones).some(key => key === timezone)) {
    return deprecatedTimezones.deprecatedTimezones[timezone];
  } else {
    return timezone;
  }
}

exports.mapDeprecatedTimezones = mapDeprecatedTimezones;
